module.exports = __webpack_public_path__ + "static/media/M001-account.1cd334ce.svg";